import { BaseService } from "./BaseService";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";

export class ProfilerService extends BaseService {
  burgissUniverseCalcIRRPercentile(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.IRRProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRRProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcMIRRProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.MIRRProfiler,
      indexID,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcMIRRProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcRIRRProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.RIRRProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcRIRRProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcDPIProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.DPIProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcDPIProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcRVPIProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.RVPIProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcRVPIProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcTVPIProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.TVPIProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcTVPIProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcDistributionsProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.DistributionsProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcDistributionsProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcDistributions_AnnualProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.Distributions_AnnualProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcDistributions_AnnualProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcNetCashFlowProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.NetCashFlowProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcNetCashFlowProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcNetCashFlow_AnnualProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.NetCashFlow_AnnualProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcNetCashFlow_AnnualProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcPaidInCapitalProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.PaidInCapitalProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcPaidInCapitalProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcPaidInCapital_AnnualProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.PaidInCapital_AnnualProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcPaidInCapital_AnnualProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcValuationProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.ValuationProfiler,
      null,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcValuationProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcGGS_DirectAlphaProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.GSS_DirectAlphaProfiler,
      indexID,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcGGS_DirectAlphaProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcKS_PMEProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.KS_PMEProfiler,
      indexID,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcKS_PMEProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcLN_ICMIRRProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMIRRProfiler,
      indexID,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMIRRProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcLN_ICMIRRSpreadProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMIRRSpreadProfiler,
      indexID,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMIRRSpreadProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  burgissUniverseCalcLN_ICMValuationSpreadProfiler(
    peergroupID?: any[][],
    percentile?: any,
    year?: any,
    currency?: string,
    indexID?: string,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      percentile,
      year,
      currency,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMValuationSpreadProfiler,
      indexID,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMValuationSpreadProfiler",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.Profiler
    );
  }

  createPayload(
    peerGroupId: any[][] = null,
    percenTile: any = null,
    year: any = null,
    uaCurrency: string = null,
    returnConstituentCount: any = null,
    filter: any = "",
    measure: string = null,
    index: any = null,
    alias: string = null
  ) {
    filter = "ExcelDna.Integration.ExcelMissing";
    const profilerObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: String(peerGroupId).toUpperCase() == "ALL" ? "-1" : String(peerGroupId),
      percentile: percenTile,
      currency: uaCurrency,
      returnConstituentCount: returnConstituentCount,
      investmentID: null,
      portfolioID: null,
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: true,
      alternateBaseCurrency: null,
      attributeName: null,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: null,
      endDate: null,
      year: year,
      indexID: index,
      premium: null,
      idType: null,
      selectionsetID: null,
      assetID: null,
      weightingMethod: null,
      value: null,
      filter: filter,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: null,
      weight: null,
      commitment: null,
    };
    return profilerObject;
  }
}
